import type { ReactNode } from 'react'

import { useAuth } from '@/features/auth/hooks/useAuth'
import NotFoundPage from '@/features/sessions/pages/NotFoundPage'

interface RequireAdminProps {
  children: ReactNode
}

/**
 * Guard de rutas /admin/*. Renderiza children solo si el usuario actual
 * tiene role ADMIN. Para cualquier otro caso (USER, anónimo) pinta
 * NotFoundPage — 404 silencioso, no revelamos que la sección existe.
 *
 * Durante el boot del auth store (status 'idle' | 'booting') pintamos un
 * loader simple para evitar un flash de 404 mientras se rehidrata el access
 * token desde el refresh cookie.
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { user, status } = useAuth()

  if (status === 'idle' || status === 'booting') {
    return <div className="container py-8 text-center text-muted-foreground">…</div>
  }

  if (!user || user.role !== 'ADMIN') {
    return <NotFoundPage />
  }

  return <>{children}</>
}
